import { render } from "./TeamAssignment.vue?vue&type=template&id=4ba211d3"
import script from "./TeamAssignment.vue?vue&type=script&lang=js"
export * from "./TeamAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__